<template>
  <!-- 報告完了のメッセージ。#2234 のサンクスダイアログと同じ見せ方に揃える（スナックバーでは流れてしまうため）。 -->
  <v-dialog
    :model-value="true"
    :retain-focus="false"
    max-width="640"
    persistent
  >
    <section
      class="hrr-thanks"
      role="dialog"
      aria-modal="true"
      :aria-label="MESSAGE_LINES[0]"
    >
      <p
        v-for="(line, index) in MESSAGE_LINES"
        :key="index"
        class="hrr-thanks__body"
      >
        {{ line }}
      </p>
      <div class="hrr-thanks__actions">
        <v-btn
          color="#9e9e9e"
          variant="flat"
          min-width="112"
          @click="emit('close')"
        >
          閉じる
        </v-btn>
      </div>
    </section>
  </v-dialog>
</template>

<script setup lang="ts">
// 文言はこの1か所に持つ。報告結果によって出し分けない。
const MESSAGE_LINES = [
  "ご報告くださりありがとうございました。",
  "複数の医療者で今後の対応について検討させていただきます。"
];

const emit = defineEmits<{
  close: [];
}>();
</script>

<style lang="scss" scoped>
.hrr-thanks {
  background-color: #fff;
  border-radius: 4px;
  padding: 48px 32px;
  text-align: center;
}

.hrr-thanks__body {
  font-size: 16px;
  line-height: 1.8;
}

.hrr-thanks__actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}
</style>
